import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Tooltip } from "radix-ui";
import { type ReactNode, useState } from "react";
import { AuthProvider } from "@/shared/auth/auth.context";
import { Toaster } from "@/shared/components/ui/sonner";
import { EntitlementsProvider } from "@/shared/entitlements/entitlements.context";
import { ThemeProvider } from "@/shared/hooks/use-theme";
import { IntegrationConsentProvider } from "@/shared/integrations/integration-consent";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(makeQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <IntegrationConsentProvider>
          <AuthProvider>
            <EntitlementsProvider>
              <Tooltip.Provider delayDuration={150}>
                {children}
                <Toaster />
              </Tooltip.Provider>
            </EntitlementsProvider>
          </AuthProvider>
        </IntegrationConsentProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
